import React, { FC, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { CommissionsStatusEnum } from '@sparling/financial-common'
import { GreenButton } from '../Buttons/GreenButton'
import { openApproveCommissionsModal, openRejectCommissionsModal } from '../../store/actions'

interface DoubleActionsProps {
  id: string | number
  status?: unknown
}

export const DoubleActions: FC<DoubleActionsProps> = ({ id, status }) => {
  const dispatch = useDispatch()

  const handleReject = useCallback(() => {
    dispatch(openRejectCommissionsModal({ open: true, ids: [Number(id)] }))
  }, [dispatch, id])

  const handleApprove = useCallback(() => {
    dispatch(openApproveCommissionsModal({ open: true, ids: [Number(id)] }))
  }, [dispatch, id])

  return (
    <>
      <GreenButton
        width={80}
        ml={8}
        text={'Reject'}
        height={40}
        backgroundColor={'#C92A2A'}
        onClick={handleReject}
        disabled={status === CommissionsStatusEnum.REJECTED || status === CommissionsStatusEnum.APPROVED}
      />
      <GreenButton
        width={80}
        ml={8}
        text={'Approve'}
        height={40}
        onClick={handleApprove}
        disabled={status === CommissionsStatusEnum.APPROVED}
      />
    </>
  )
}
